/* eslint-disable array-callback-return */
/* eslint-disable no-case-declarations */
import isEmpty from "../../validation/isEmpty";
import { types } from "../type";

const initialState = {
  users: [],
  userId: "",
  toDate: "",
  filter: "",
  devices: [],
  workerId: "",
  fromDate: "",
  userError: "",
  userStatus: 0,
  dynamic: false,
  locationId: "",
  shiftError: "",
  shiftStatus: 0,
  userResponse: "",
  userDetail: null,
  shiftResponse: "",
  selectedInputs: [],
  activeStatus: true,
  userLoading: false,
  // previousPage: null,
  totalAwsUsers: null,
  shiftLoading: false,
  userAddLoading: false,
  addDeviceLoading: false,
  allUserForAccess: [],
  allUserImages: [],
  userCalendarData: {},
  selectedDepartment: "",
  shiftChangesError: null,
  deleteFaceSuccess: null,
  nextPage: {
    page: 1,
    limit: 100
  },
  previousPage: null
};

const userReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.UserTypes.ADD_DEVICE_SET_LOADING:
      return {
        ...state,
        addDeviceLoading: payload
      };
    case types.UserTypes.USER_SET_LOADING:
      return {
        ...state,
        userLoading: payload
      };
    case types.UserTypes.ADD_LOCATION_TO_USER_LOADING:
      return {
        ...state,
        userAddLoading: payload
      };
    case types.UserTypes.USER_CLEAR_ERRORS:
      return {
        ...state,
        userError: "",
        deleteFaceSuccess: null
      };
    case types.UserTypes.USER_GET_ERRORS:
      return {
        ...state,
        userLoading: false,
        userAddLoading: false,
        userError: payload.data.message,
        userStatus: payload.status
      };
    case types.UserTypes.USER_CLEAR_RESULT:
      return {
        ...state,
        userResponse: ""
      };
    case types.UserTypes.GET_DEVICE:
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        devices: payload.data.foundDevices
      };
    case types.UserTypes.ADD_DEVICE:
      return {
        ...state,
        userLoading: false,
        addDeviceLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message
      };
    case types.UserTypes.ADD_PHOTO:
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message
      };
    case types.UserTypes.ADD_LOCATION_TO_USER:
      return {
        ...state,
        userAddLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message
        // userDetail: payload.updatedUser
      };
    case types.UserTypes.USER_RESET_PASSWORD:
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message
      };
    case types.UserTypes.DELETE_FACE:
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message,
        deleteFaceSuccess: payload.success
      };
    case types.UserTypes.EDIT_USER:
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message
      };
    case types.UserTypes.CHANGE_PASSWORD:
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message
      };
    case types.UserTypes.GET_USER_CALENDAR_DATA:
      return {
        ...state,
        userLoading: false,
        userCalendarData: payload.data.attendanceSheet[0]
      };
    case types.UserTypes.GET_ALL_USERS_IMAGES:
      return {
        ...state,
        userLoading: false,
        nextPage: payload.data.next,
        previousPage: payload.data.previous,
        allUserImages: payload.data.allUserImages
      };
    case types.UserTypes.USER_GEO_FENCE:
      const geoFenceUser = payload.allUsers.map((foundUser) => {
        if (foundUser.select) {
          foundUser.allowFencing = payload.isGeoFencing;
          foundUser.select = false;
        }
        return foundUser;
      });
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message,
        users: geoFenceUser
      };
    case types.UserTypes.GEO_ACTIVE_RESTRICT:
      const statusChangedUser = payload.allUsers.map((foundUser) => {
        if (foundUser.select) {
          foundUser[payload.type] = payload.typeValue;
          foundUser.select = false;
        }
        return foundUser;
      });

      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message,
        users: statusChangedUser
      };
    case types.UserTypes.DELETE_USER:
      const deActivateUser = payload.allUsers.map((foundUser) => {
        if (foundUser.select) {
          foundUser.isActive = payload.isActive;
          foundUser.select = false;
        }
        return foundUser;
      });
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message,
        users: deActivateUser
      };
    case types.UserTypes.ASSIGN_RULE_TO_USER:
      const assignRuleUsers = payload.allUsers.map((foundUser) => {
        if (foundUser.select) {
          foundUser.select = false;
          foundUser.defaultShiftCode = payload.ruleCode;
        }
        return foundUser;
      });
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userResponse: payload.message,
        users: assignRuleUsers
      };
    case types.UserTypes.GET_USERS:
      const usersArray = payload.data.users.map((userData) => {
        const newArrayDynamic = [];
        payload.payloadData.map((selectValue) => {
          newArrayDynamic.push({
            label: selectValue.label,
            value: userData[selectValue.value]
          });
        });

        const newArray = Object.assign({}, userData);
        newArray.select = false;
        newArray.workerFullName =
          userData.workerFirstName + " " + userData.workerSurname;
        newArray.shiftCode = !isEmpty(userData.shiftCode)
          ? userData.shiftCode
          : "-";
        newArray.dataArray = newArrayDynamic;
        return newArray;
      });

      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        users:
          payload.dataType === "initial"
            ? usersArray
            : [...state.users, ...usersArray],
        nextPage: payload.data.next,
        previousPage:
          typeof payload.data.previous === "undefined"
            ? null
            : payload.data.previous
      };
    case types.UserTypes.GET_USER_DETAIL:
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        userDetail: payload.data.userDetail
      };
    case types.UserTypes.GET_USERS_FOR_ACCESS:
      return {
        ...state,
        userLoading: false,
        userError: "",
        userStatus: 0,
        allUserForAccess: payload
      };
    case types.UserTypes.ALL_USER_INPUTS:
      return {
        ...state,
        date: payload.date,
        filter: payload.filter,
        workerId: payload.workerId,
        dynamic: payload.isDynamic,
        activeStatus: payload.status,
        locationId: payload.locationId,
        selectedInputs: payload.selectedValues,
        selectedDepartment: payload.userDepartment
      };
    case types.UserTypes.ALL_USER_INPUTS_DYNAMIC:
      return {
        ...state,
        date: payload.date,
        locationId: payload.locationId,
        workerId: payload.workerId,
        selectedInputs: payload.selectedValues,
        dynamic: payload.isDynamic
      };
    case types.UserTypes.USER_WISE_ATTEND_INPUT:
      return {
        ...state,
        userId: payload.userId,
        fromDate: payload.dateRange.fromDate,
        toDate: payload.dateRange.toDate
      };
    case types.UserTypes.USER_UNMOUNT:
      return {
        ...state,
        users: []
        // toDate: "",
        // userId: "",
        // fromDate: "",
        // locationId: "",
        // activeStatus: true,
        // userCalendarData: {}
      };
    case types.UserTypes.SHIFT_SET_LOADING:
      return {
        ...state,
        shiftLoading: payload
      };
    case types.UserTypes.SHIFT_CLEAR_ERROR:
      return {
        ...state,
        shiftError: "",
        shiftChangesError: null
      };
    case types.UserTypes.SHIFT_GET_ERRORS:
      return {
        ...state,
        shiftLoading: false,
        shiftError: payload.data.message,
        shiftStatus: payload.status
      };
    case types.UserTypes.SHIFT_CLEAR_RESULT:
      return {
        ...state,
        shiftResponse: ""
      };
    case types.UserTypes.SHIFT_CHANGE:
      return {
        ...state,
        shiftLoading: false,
        shiftResponse: payload.message,
        shiftChangesError: payload.errors
      };
    case types.UserTypes.SHIFT_REGISTER_CSV:
      return {
        ...state,
        shiftLoading: false,
        shiftError: "",
        shiftStatus: 0,
        shiftResponse: payload.message,
        shiftChangesError: payload.errors
      };
    default:
      return state;
  }
};

export default userReducer;
